import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import { setHeaderTitle } from 'store/header/header-actions';
export const useHeaderSync = () => {
    const dispatch = useDispatch();
    const { parkingType, destination } = useReduxSearchState();
    useEffect(() => {
        const isVenueParking = parkingType === 'transient' && destination?.can_have_events;
        const isEventParking = parkingType === 'event';
        const title = (isVenueParking || isEventParking) && destination?.title
            ? `${destination.title} Event Parking`
            : null;
        dispatch(setHeaderTitle(title));
    }, [dispatch, parkingType, destination]);
};
